import { VisibleColumnsType } from '../types';

export const isColumnVisible = (config: VisibleColumnsType, pageId: string): boolean => {
  return config[pageId] === true;
};
